<div>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1><i class="fa fa-bug"></i> Devtool</h1>
        </div>
      </div>
    </div>
  </section>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          URL : 
          <input type="text" style="width: 60%;" [(ngModel)]="scope.url">
          <button (click)="submit()">CHECK</button>
          <img src="http://192.168.200.200:32706/video_feed" style="width: 100%; align-content: center;">
        </div>
      </div>
    </div>
  </section>
</div>
